var map = {
	"./en.json": [
		"c4b9",
		"chunk-2d2170fe"
	],
	"./es-MX.json": [
		"e1d3",
		"chunk-2d224eb1"
	],
	"./es.json": [
		"e160",
		"chunk-2d22491c"
	],
	"./fr.json": [
		"4b00",
		"chunk-2d0cba24"
	],
	"./ru.json": [
		"312d",
		"chunk-2d0b8e46"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "b912";
module.exports = webpackAsyncContext;